import { render, staticRenderFns } from "./FooterA.vue?vue&type=template&id=ec35bdba&scoped=true&"
import script from "./FooterA.vue?vue&type=script&lang=js&"
export * from "./FooterA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec35bdba",
  null
  
)

export default component.exports